import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useActiveOrg } from "context/ActiveOrgContext";

const CLINICS_PREFIX = "/app/clinics";

/**
 * When the user has no organisations, only `/app/clinics` (and sub-routes) are allowed.
 * Otherwise redirect so they can create or join a clinic.
 * If the organisations could not be loaded, show the error instead of redirecting:
 * a failed fetch does not mean the user has no clinics.
 */
export function RequireOrganisation({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const { loading, organisations, error } = useActiveOrg();

  const onClinicsRoute =
    pathname === CLINICS_PREFIX || pathname.startsWith(`${CLINICS_PREFIX}/`);

  if (!loading && !error && organisations.length === 0 && !onClinicsRoute) {
    return <Navigate to="/app/clinics" replace />;
  }

  return (
    <>
      {error && (
        <div className="mb-4 rounded-md border border-red-100 bg-red-50 px-3 py-2 text-sm text-red-700">
          Could not load your clinics: {error}
        </div>
      )}
      {children}
    </>
  );
}
